export const PASSWORD_MAX_LENGTH = 40
